<template>
  <section class="policy-tab">
    <aside>
      <h2>Policy Periods</h2>
      <div
        v-for="(item, index) in recordList"
        :key="index + item.type_language"
        class="policy-list">
        <div
          class="policy-item"
          :class="{'active': index == activeItem }"
          @click="recordClick(index, item)"
        >
          <span class="bold">{{ item.type_language }}</span>
          <span>{{ item.period }}</span>
        </div>
        <div
          v-if="item.period_record && item.period_record.length > 0"
          class="policy-status-list">
          <div
            v-for="(inItem, inIndex) in item.period_record"
            :key="inIndex + index"
            class="policy-status-item"
            :class="{'active': (index == activeItem && inIndex == activeInItem) }"
            @click="recordItemClick(index, inIndex, inItem)">
            <span
              class="bold"
            >{{ inItem.type_language }}</span>
            <span class="time">{{ inItem.period_start }}</span>
          </div>
        </div>
      </div>
    </aside>
    <section class="information-container">
      <section
        v-show="activeTab == 'Policy'"
        @click="tableClick">
        <!--        TODO v-if="productId == 11"-->
        <cover-note
          v-if="false"
          :orderId="order_id"
          :coverNoteStatus="coverNoteStatus"
          :coverNoteNum="coverNoteNum"
          :pcyStts="pcyStts"
          @refreshData="handleRefreshData"
          @loading="hanldeLoading"></cover-note>
        <div
          v-if="showAdjustPolicyBtn"
          class="text-right mg-b-15">
          <v-button
            type="primary"
            gray
            :disabled="disabledAdjustPolicyBtn"
            @click="onAdjustPolicy">Adjust Policy
          </v-button>
        </div>
        <div
          v-if="formData.adjust_quote_order_id"
          class="status-bar status-bar-payment flex-sb">
          <div class="left">
            <span>Payment Pending</span>
            <span>There’s a payment pending to adjust this policy.</span>
          </div>
          <div class="right">
            <v-button @click="routerToQuote(formData.adjust_quote_order_id)">View Quote</v-button>
          </div>
        </div>
        <div
          v-if="formData.adjust_void_order_id"
          class="status-bar status-bar-void flex-sb">
          <div class="left">
            <span>Void Quote</span>
            <span> An adjustment quote was voided along with this policy.</span>
          </div>
          <div class="right">
            <v-button @click="routerToQuote(formData.adjust_void_order_id)">View Quote</v-button>
          </div>
        </div>
        <housemaid-policy-detail-info
          v-if="productId == 12"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <decoration-policy-detail-info
          v-else-if="productId == 15"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <working-policy-detail-info
          v-else-if="productId == 13"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <travel-policy-detail-info
          v-else-if="productId == 14"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <student-policy-detail-info
          v-else-if="productId == 16"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <homefire-policy-detail-info
          v-else-if="productId == 17"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <personal-policy-detail-info
          v-else-if="productId == 18"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <fire-policy-detail-info
          v-else-if="productId == 20"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <pet-policy-detail-info
          v-else-if="productId == 22"
          :preFormData="preformData"
          :showAmount="showAmount"
          :isChange="isChange"
          :formData="formData"/>
        <template v-else-if="productId==80&&!isNewSME">
          <sme-policy-detail-info :form-data="formData"></sme-policy-detail-info>
        </template>
        <template v-else-if="isNewSME">
          <sme-kyc-info
            is-policy
            :form-data="formData"
            @showPre="handleShowPremium"></sme-kyc-info>
        </template>
        <template v-else>
          <table class="table">
            <tr class="tr">
              <td>Effective Time</td>
              <td
                :class="{
                  'green-tip':handleCompare('pcy_cmnt_date'),
                }">
                <alt-copy
                  key_value="pcy_cmnt_date"
                  :text="formData.pcy_cmnt_date"
                  :copyKey="copyKey"
                  className="key-alt-down"
                  @sendKey="getKey"></alt-copy>
              </td>
            </tr>
            <tr class="tr">
              <td>Insured Period</td>
              <td
                :class="{
                  'green-tip':handleCompare('insurance_period'),
                }">
                <alt-copy
                  key_value="insurance_period"
                  :text="formData.insurance_period"
                  :copyKey="copyKey"
                  className="key-alt-down"
                  @sendKey="getKey"></alt-copy>
              </td>
            </tr>
            <tr class="tr">
              <td>Expected Insured Period</td>
              <td
                :class="{
                  'green-tip':handleCompare('period_date'),
                }">
                <!-- {{ formData.period_date }} -->
                <alt-copy
                  key_value="period_date"
                  :text="formData.period_date"
                  :copyKey="copyKey"
                  className="key-alt-down"
                  @sendKey="getKey"></alt-copy>
                <span
                  v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
                  class="asap">(ASAP)</span>
              </td>
            </tr>
            <tr
              v-if="formData.cvr_period"
              class="tr">
              <td>Cover Note Period</td>
              <td
                :class="{
                  'green-tip':handleCompare('cvr_period'),
                }">
                <!-- {{ formData.period_date }} -->
                <alt-copy
                  key_value="cvr_period"
                  :text="formData.cvr_period"
                  :copyKey="copyKey"
                  className="key-alt-down"
                  @sendKey="getKey"></alt-copy>
              </td>
            </tr>
            <tr class="tr">
              <td>Total Price</td>
              <td
                v-if="showAmount"
                :class="{
                  'green-tip':isChange,
                }">
                <!-- {{ showAmount | formatMoney(2, true) }} -->
                <alt-copy
                  key_value="showAmount"
                  :text="showAmount | formatMoney(2, true)"
                  :copyKey="copyKey"
                  className="key-alt-down"
                  @sendKey="getKey"></alt-copy>
              </td>
            </tr>
            <tr class="tr">
              <td>Referrer</td>
              <td
                v-if="referrer"
              >
                <referrer-info :referrer="referrer"></referrer-info>
              </td>
            </tr>
            <tr
              v-if="formData.discount_str&&!isFina"
              class="tr">
              <td>Referrer Discount</td>
              <td>{{formData.discount_str}}</td>
            </tr>
            <template   v-if="!isEndorse">
              <tr
                v-if="!isHzmb"
                class="tr">
                <td>Policy Number </td>
                <td :class="{'green-tip':handleCompare('pcy_no')}">
                  <!-- {{ formData.pcy_no  }} -->
                  <alt-copy
                    key_value="pcy_no"
                    :text="formData.pcy_no"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
              <template v-else>
                <tr
                  class="tr">
                  <td>交强險 </td>
                  <td :class="{'green-tip':handleCompare('pcy_no')}">
                    <!-- {{ formData.pcy_no  }} -->
                    <alt-copy
                      key_value="pcy_no"
                      :text="formData.pcy_no"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </td>
                </tr>
                <tr
                  class="tr">
                  <td>優粵行 </td>
                  <td :class="{'green-tip':handleCompare('pcy_no_2')}">
                    <!-- {{ formData.pcy_no  }} -->
                    <alt-copy
                      key_value="pcy_no_2"
                      :text="formData.pcy_no_2"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </td>
                </tr>
                <tr
                  class="tr">
                  <td>商業險 </td>
                  <td :class="{'green-tip':handleCompare('pcy_no_3')}">
                    <!-- {{ formData.pcy_no  }} -->
                    <alt-copy
                      key_value="pcy_no_3"
                      :text="formData.pcy_no_3"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </td>
                </tr>
              </template>
            </template>
            <tr
              v-else
              class="tr">
              <td>Endorsement Number </td>
              <td
                v-copy="formData.endorser_no"
                :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</td>
            </tr>
            <tr
              v-if="!isHzmb"
              class="tr">
              <td>Cover Note Number</td>
              <td  :class="{'green-tip':handleCompare('cvr_nt_no')}">
                <!-- {{ formData.cvr_nt_no }} -->
                <alt-copy
                  key_value="cvr_nt_no"
                  :text="formData.cvr_nt_no"
                  :copyKey="copyKey"
                  className="key-alt-down"
                  @sendKey="getKey"></alt-copy>
              </td>
            </tr>
            <tr class="tr">
              <td>Policy Reference Code </td>
              <td  :class="{'green-tip':handleCompare('order_sn')}">
                <!-- {{ formData.order_sn }} -->
                <alt-copy
                  key_value="order_sn"
                  :text="formData.order_sn"
                  :copyKey="copyKey"
                  className="key-alt-down"
                  @sendKey="getKey"></alt-copy>
              </td>
            </tr>
            <template v-if="formData.class_id !== 14">
              <tr
                v-if="!isHzmb"
                class="tr">
                <td>Insurance Type</td>
                <td :class="{'green-tip':handleCompare('trm_of_cvr')}">
                  <!-- {{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }} -->
                  <alt-copy
                    key_value="trm_of_cvr"
                    :text="getOptionName('coverTypeOptions', formData.trm_of_cvr)"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
              <tr
                v-if="formData.trm_of_cvr != 1&&!isHzmb"
                class="tr">
                <td>Sum Insured</td>
                <td  :class="{'green-tip':handleCompare('isrd_vl')}">
                  <!-- {{ formData.isrd_vl | formatMoney(2, true) }} -->
                  <alt-copy
                    key_value="isrd_vl"
                    :text="formData.isrd_vl | formatMoney(2, true)"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
              <tr
                v-if="formData.trm_of_cvr != 1||isHzmb"
                class="tr">
                <td>Hire Purchase Owner</td>
                <td :class="{'green-tip':handleCompare('hp_ind')}">
                  <!-- {{ getOptionName('yesNoOptions', formData.hp_ind) }} -->
                  <alt-copy
                    key_value="hp_ind"
                    :text="getOptionName('yesNoOptions', formData.hp_ind)"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
              <tr
                v-if="(formData.trm_of_cvr != 1||isHzmb) && formData.hp_ind == 1"
                class="tr">
                <td>Name of Hire Purchase Owner (If Yes for Hire purchase)</td>
                <td
                  v-if="!isMortgagorOther"
                  :class="{'green-tip':handleCompare('mortgagor')}">
                  <!-- {{ getLocalAllOptionName('mortgagor', formData.mortgagor)}} -->
                  <alt-copy
                    key_value="mortgagor"
                    :text="getLocalAllOptionName('mortgagor', formData.mortgagor)"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
                <td
                  v-else
                  :class="{'green-tip':handleCompare('mortgagor_other')}">
                  <!-- {{  formData.mortgagor_other}} -->
                  <alt-copy
                    key_value="mortgagor_other"
                    :text="formData.mortgagor_other"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
              <template   v-if="isMotorTrade">
                <tr class="tr">
                  <td>Type of insurance</td>
                  <td>
                    <alt-copy
                      key_value="type_of_ins"
                      :text="getAllOptionName13('type_of_ins',formData.type_of_ins)"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </td>
                </tr>
                <tr class="tr">
                  <td>No Claims in the past 3 years?</td>
                  <td>
                    <alt-copy
                      key_value="type_of_ins"
                      :text="getOptionName('yesNoOptions',formData.no_claim_3_year)"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </td>
                </tr>
              </template>
            </template>
            <tr
              v-if="option_benefits.length>0"
              class="tr">
              <td>Optional Benefits</td>
              <td>
                <span
                  v-for="(item,index) in option_benefits"
                  :key="'extra'+index">
                  <!-- {{item.item}}<br> -->
                  <alt-copy
                    :key_value="'option'+index"
                    :text="item.item"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </span>
              </td>
            </tr>
            <tr
              v-if="formData.class_id==11&&extraBenefitSelect.length>0&&!isFina"
              class="tr">
              <td>Extra Benefits</td>
              <td>
                <template v-for="(item,index) in extraBenefitSelect">
                  <span
                    v-if="Array.isArray(formData.extra_benefits) && formData.extra_benefits.includes(item.id)"
                    :key="'extra'+index">
                    <!-- {{item.name}}<br> -->
                    <alt-copy
                      :key_value="'extra'+index"
                      :text="item.name"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </span>
                </template>
              </td>
            </tr>
            <template
              v-if="extra_content_pcy.length>0"
            >
              <tr
                v-for="(item,index) in extra_content_pcy"
                :key="'pcy'+index"
                class="tr">
                <td>
                  {{item.name}} Policy No.
                </td>
                <td>
                  <!-- {{item.pcy_no}} -->
                  <alt-copy
                    :key_value="'pcy'+index"
                    :text="item.pcy_no"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
            </template>
          </table>
          <div
            v-if="!isHzmb"
            class="box">
            <h3>Excess</h3>
            <table class="table">
              <tr class="tr th">
                <th>Item</th>
                <th>Amount</th>
              </tr>
              <tr
                v-for="(inItem, index) in excessList"
                :key="index + inItem.premium"
                class="tr">
                <td>{{ inItem.item }}</td>
                <td>
                  <!-- {{ inItem.premium }} -->
                  <alt-copy
                    :key_value="index + inItem.premium"
                    :text="inItem.premium"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
              <tr class="tr">
                <td>Excess Remark</td>
                <td
                  :class="{'green-tip':handleCompare('quote_remark')}">
                  <alt-copy
                    key_value="quote_remark"
                    :text="changeLineData(formData.quote_remark)"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
            </table>
          </div>
          <div class="box">
            <div
              v-for="(excessItem, excessIndex) in coverageList.items"
              :key="'coverage' + excessIndex">
              <table
                v-if="excessItem.sub_items.length>0"
                class="table">
                <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
                <tr
                  v-if="excessIndex==0"
                  class="tr th">
                  <th>Item</th>
                  <th>Information</th>
                </tr>
                <tr
                  v-for="(subItem, subIndex) in excessItem.sub_items"
                  :key="'coverage-' + excessIndex + subIndex"
                  class="tr">
                  <td>{{ subItem.item }}</td>
                  <td>
                    <!-- {{ subItem.premium }} -->
                    <alt-copy
                      :key_value="'coverage-' + excessIndex + subIndex"
                      :text="subItem.premium"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </td>
                </tr>
                <tr class="tr">
                  <td>Coverage Remark</td>
                  <td
                    :class="{'green-tip':handleCompare('quote_remark')}">
                    <alt-copy
                      key_value="cvr_remark"
                      :text="changeLineData(formData.cvr_remark)"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </td>
                </tr>
              </table>
            </div>
            <template v-if="extra_content_premium.length>0&&!isFina">
              <h3 class="extra-title">Extra Benefits</h3>
              <div
                v-for="(excessItem, excessIndex) in extra_content_premium"
                :key="'ext' + excessIndex">
                <table
                  class="table">
                  <tr
                    class="tr ">
                    <td>
                      {{excessItem.name}}
                    </td>
                  </tr>
                  <tr
                    v-if="excessItem.content.coverage.length>0"
                    class="td  ">
                    <span class="color-dark fw-600 mg-t-5">coverage</span>
                  </tr>
                  <tr
                    v-for="(subItem, subIndex) in excessItem.content.coverage"
                    :key="'coverage-extra' + excessIndex + subIndex"
                    class="tr">
                    <td>{{ subItem.name }}</td>
                    <td>
                      <!-- {{ subItem.money }} -->
                      <alt-copy
                        :key_value="'coverage-extra' + excessIndex + subIndex"
                        :text="subItem.money"
                        :copyKey="copyKey"
                        className="key-alt-down"
                        @sendKey="getKey"></alt-copy>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </div>
          <div
            v-if="specialList.length>0"
            class="box">
            <h3>{{specialData.title}}</h3>
            <table class="table">
              <tr
                v-for="(inItem, index) in specialList"
                :key="index + inItem.key"
                class="tr">
                <td></td>
                <td>
                  <!-- {{ inItem.val }} -->
                  <alt-copy
                    :key_value="index + inItem.key"
                    :text="inItem.val"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
            </table>
          </div>
          <div class="box">
            <h3>Policyholder</h3>
            <policy-holder-info
              :form="formData"
              :compareList="compareList"/>
          </div>
          <div
            v-if="!isMotorTrade"
            class="box">
            <!--            <h3>Insured Vehicle</h3>-->
            <h3 v-if="formData.class_id == 14">Insured Motorcycle Details</h3>
            <h3 v-if="formData.class_id == 11||isHzmb">Insured Private Details</h3>
            <h3 v-if="formData.class_id == 12">Insured Commercial Vehicle Details</h3>

            <insured-vehicle-info
              :form="formData"
              :compareList="compareList"/>
          </div>
          <div
            v-if="!isMotorTrade||isMotorTrade&&isTPlate"
            class="box">
            <h3>Insured Driver(s)</h3>
            <drivers-info
              :form="formData"
              :preFormData="preformData"/>
          </div>
          <div class="box">
            <h3>Remark(s)</h3>
            <table class="table strip">
              <tr class="tr">
                <td>Remark</td>
                <td>
                  <alt-copy
                    key_value="cs_manual_remark"
                    :text="changeLineData(formData.cs_manual_remark)"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                </td>
              </tr>
            </table>
          </div>
        </template>
        <template v-if="!isNewSME">
          <template>
            <!-- no endorsement -->
            <template  v-if="!showEndorsementPremium">
              <div
                v-if="productId!=80"
                class="box">
                <div class="flex flex-aglin-icon">
                  <h3>Premium</h3>
                  <font-awesome-icon
                    class="icon"
                    icon="info-circle"
                    @click="handleShowPremium()"></font-awesome-icon>
                </div>
                <table class="table">
                  <tr class="tr th">
                    <th>Item</th>
                    <th>Amount</th>
                  </tr>
                  <tr
                    v-for="(item,index) in sidebarPremium"
                    :key="'sude'+index"
                    class="tr">
                    <template v-if="item.item == 'MGM Discount'">
                      <td>
                        <div class="flex">
                          <span v-html="changeLineData(item.item)"></span>
                          <span
                            v-if="formData.code"
                            class="mg-l-8">{{formData.code}}</span>
                        </div>
                      </td>
                      <td
                        v-copy="item.premium_str"
                      >{{ item.premium_str }}</td>
                    </template>
                    <template v-else>
                      <td v-html="changeLineData(item.item)"></td>
                      <td>
                        <!-- {{ item.premium_str }} -->
                        <alt-copy
                          :key_value="'sude'+index"
                          :text="item.premium_str"
                          :copyKey="copyKey"
                          className="key-alt-down"
                          @sendKey="getKey"></alt-copy>
                      </td>
                    </template>
                  </tr>
                </table>
              </div>
              <section
                v-else
                class="sme-container__info">
                <div
                  class="box">
                  <table class="table">
                    <th class="th">
                      <div class="flex flex-aglin-icon">
                        <span class="fw-600">Premium</span>
                        <font-awesome-icon
                          class="icon"
                          icon="info-circle"
                          @click="handleShowPremium()"></font-awesome-icon>
                      </div>
                    </th>
                    <tr
                      v-for="(item,index) in sidebarPremium"
                      :key="'sude'+index"
                      class="tr">
                      <td
                        class="fw-600"
                        v-html="changeLineData(item.item)"></td>
                      <td>
                        <!-- {{ item.premium_str }} -->
                        <alt-copy
                          :key_value="'sude'+index"
                          :text="item.premium_str"
                          :copyKey="copyKey"
                          className="key-alt-down"
                          @sendKey="getKey"></alt-copy>
                      </td>
                    </tr>
                  </table>
                </div>
              </section>
            </template>
            <div
              v-else
              class="box">
              <div class="flex flex-aglin-icon">
                <h3>{{isEndorse?'Endorsement':'Adjustment'}} Premium</h3>
                <font-awesome-icon
                  class="icon"
                  icon="info-circle"
                  @click="handleShowPremium()"></font-awesome-icon>
              </div>
              <span
                v-if="productId!==11"
                class="sub-title">Difference Payable</span>
              <table class="table">
                <tr class="tr th">
                  <th>Item</th>
                  <!--                  <span>Percentage</span>-->
                  <th>Amount</th>
                </tr>
                <tr
                  v-for="(item,index) in sidebarPremium"
                  :key="'sude'+index"
                  class="tr">
                  <td>{{item.item}}</td>
                  <td>
                    <!-- {{ item.premium_str }} -->
                    <alt-copy
                      :key_value="'sude'+index"
                      :text="item.premium_str"
                      :copyKey="copyKey"
                      className="key-alt-down"
                      @sendKey="getKey"></alt-copy>
                  </td>
                </tr>
              </table>
            </div>
          </template>
          <div class="box">
            <h3>Direct Marketing Consent</h3>
            <table class="table strip">
              <tr class="tr">
                <td>Marketing Consent</td>
                <td
                  v-if="formData.marketing_data"
                  class="marketing">
                  <!-- {{getOptionName('consentOptions',formData.marketing_data.is_use)}} -->
                  <alt-copy
                    key_value="is_use"
                    :text="getOptionName('consentOptions',formData.marketing_data.is_use)"
                    :copyKey="copyKey"
                    className="key-alt-down"
                    @sendKey="getKey"></alt-copy>
                  <template v-if="!formData.marketing_data.is_use">
                    <div
                      v-if="Array.isArray(formData.marketing_data.use_data)"
                      class="op">
                      <p
                        v-for="(item, i) in marketingList"
                        :key="i">
                        <!-- {{item.name}}: {{getOptionName('consentOptions',formData.marketing_data.use_data.includes(item.id)?1:0)}} -->
                        <alt-copy
                          :key_value="'marketing'+i"
                          :text1="item.name"
                          :text="getOptionName('consentOptions',formData.marketing_data.use_data.includes(item.id)?1:0)"
                          :copyKey="copyKey"
                          className="key-alt-down"
                          @sendKey="getKey"></alt-copy>
                      </p>
                    </div>
                    <p>
                      <!-- Data-sharing: {{getOptionName('consentOptions',formData.marketing_data.other_use)}} -->
                      <alt-copy
                        key_value="other_use"
                        text1="Data-sharing"
                        :text="getOptionName('consentOptions',formData.marketing_data.other_use)"
                        :copyKey="copyKey"
                        className="key-alt-down"
                        @sendKey="getKey"></alt-copy>
                    </p>
                  </template>
                </td>
              </tr>
            </table>
          </div>
          <div class="box">
            <h3>Signature</h3>
            <div class="sign_pic">
              <img :src="sign_pic"/>
            </div>
          </div>
          <template v-if="auto_renewal_info">
            <div class="table-box">
              <div class="title flex flex-sb-center">
                <span>Auto Renew</span>
                <span
                  v-if="!auto_renewal_info.disable_on"
                  class="blue pointer "
                  @click="handleChangePaidStatus">Edit</span>
              </div>
              <div
                class="tr">
                <span>
                  Client Option
                </span>
                <span
                  :class="{'color-green':auto_renewal_info.auto_on}">{{auto_renewal_info.auto_on?'ON':'OFF'}}</span>
              </div>
            </div>
            <div class="table-box">
              <div class="title ">
                <span>Auto Paid Status</span>

              </div>

              <div class="tr">
                <span>Auto Paid Status</span>
                <span :class="{'color-green':auto_renewal_info.paid_status==2}">{{ paid_status_lang }}</span>
              </div>
              <div class="tr">
                <span>Card Record</span>
                <span :class="{'color-red':auto_renewal_info.paid_status == 3}">
                  <p
                    v-if="card_info.brand"
                    :class="{'color-red':auto_renewal_info.paid_status == 3}">{{card_info.brand}}  {{`${formatCardNumber(card_info.bin)}`}}{{card_info.last4}}</p>
                  <p
                    v-if="auto_renewal_info.emit_at"
                    class="mg-t-8"
                    :class="{'color-red':auto_renewal_info.paid_status == 3}"
                  >{{auto_renewal_info.emit_at}}</p>
                  <p
                    v-if="auto_renewal_info.error_tip"
                    class="color-red mg-t-8">
                    <font-awesome-icon
                      class="color-red mg-r-8"
                      icon="circle-exclamation"></font-awesome-icon>
                    <span class="color-red">{{auto_renewal_info.error_tip }}</span>
                  </p>
                </span>
              </div>
              <div class="tr">
                <span>Expected Auto Paid Date</span>
                <span>{{ auto_renewal_info.auto_pay_at}}</span>
              </div>
              <div class="tr">
                <span>Auto Paid Date</span>
                <span :class="{'color-green':auto_renewal_info.succeed_at}">{{ auto_renewal_info.succeed_at||'-' }}</span>
              </div>
            </div>
          </template>
        </template>
      </section>
      <section v-show="activeTab ==='Documents'">
        <document-form
          ref="document-form"
          :inter="true"
          :orderId="orderId"
          :formDataLock="formDataLock"
          :form="formData"
          :is-t-plate="isTPlate"
          :is-motor-trade="isMotorTrade"
          :policyForm="form"
          :customer="customer_profile"
          @tabName="handTabName"
          @update="() => { $emit('update') }"/>
      </section>
    </section>
    <show-premium-data
      ref="premium-dialog"
      :showPremiumData="showPremiumData">
    </show-premium-data>
    <paid-status-dialog
      v-model="showPaidStatus"
      :order-id="orderId"
      @next="handleNext"
    ></paid-status-dialog>
    <select-send-message
      v-model="showAutoSelectMessage"
      :form="form"
      :initSmsContent="renew_sms_data"
      :init-email-content="renew_email_data"
      :init-share-content="share_renew_data"
      :is-renew="true"
      :auto-pay-at="auto_pay_at"
      :is-close-share="status==0"
      :auto-renew="status==1"
      :updateContent="true"
      @send="handlerRenewSend"
      @skip="handlerRenewSkip"></select-send-message>
  </section>
</template>
<script>
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import InsuredVehicleInfo from '@/views/components/insured-vehicle-info'
import PolicyHolderInfo from '@/views/tickets/components/info/policy-holder-info'
import DriversInfo from '@/views/tickets/components/info/drivers-info'
import DocumentForm from './form/document-form'
import {
  getOrderAdjustPremium,
  getPolicyDetail,
} from '@/api/policy'
import HousemaidPolicyDetailInfo from '../modules/housemaid/housemaid-policy-detail-info'
import DecorationPolicyDetailInfo from '../modules/decoration/decoration-policy-detail-info'
import HomefirePolicyDetailInfo from '../modules/homefire/homefire-policy-detail-info'
import TravelPolicyDetailInfo from '../modules/travel/travel-policy-detail-info'
import StudentPolicyDetailInfo from '../modules/student/student-policy-detail-info'
import WorkingPolicyDetailInfo from '../modules/working/working-policy-detail-info'
import PersonalPolicyDetailInfo from '../modules/personal/personal-policy-detail-info'
import firePolicyDetailInfo from '../modules/homefire/fire-policy-detail-info'
import petPolicyDetailInfo from '../modules/pet/pet-policy-detail-info'
import ShowPremiumData from '../../../quoting/components/premium-data'
import SmePolicyDetailInfo from '@/views/records/policy/modules/sme/sme-policy-detail-info'
import {getSMEPolicyDetail} from '@api/sme'
import CoverNote from './cover-note.vue'
import {getAccountDetail} from '@/api/account'
import SmeKycInfo from '../../../sme/components/kycInfo'
import PaidStatusDialog from '@/views/records/policy/components/dialog/paid-status-dialog'
import SelectSendMessage from '@/views/components/dialogs/select-send-message'
import {turnAutoRenewal} from '@api/order'
import ReferrerInfo from '@/views/records/policy/components/info/referrer-info'
export default {
  name: 'PolicyTab',
  components: {
    ReferrerInfo,
    PaidStatusDialog,
    SmePolicyDetailInfo,
    InsuredVehicleInfo,
    PolicyHolderInfo,
    DriversInfo,
    DocumentForm,
    // HousemaidQuoteInfo
    HousemaidPolicyDetailInfo,
    DecorationPolicyDetailInfo,
    HomefirePolicyDetailInfo,
    TravelPolicyDetailInfo,
    StudentPolicyDetailInfo,
    WorkingPolicyDetailInfo,
    PersonalPolicyDetailInfo,
    firePolicyDetailInfo,
    petPolicyDetailInfo,
    ShowPremiumData,
    CoverNote,
    SmeKycInfo,
    SelectSendMessage
  },
  mixins: [MixinFormat, MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    activeTab: {
      type: [String],
      default: ''
    },
    oldFormDataLock: {
      type: Number,
      default: 0
    },
    orderId: {
      type: [Number, String],
      default: 0
    },
    pcyId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      showAutoSelectMessage:false,
      formData: {
        code_disc_prm: '',
        code_disc_pct: ''
      },
      activeItem: 0,
      activeInItem: 0,
      formDataLock: -1,
      lock:0,
      adjustPremium:[],
      preformData:{},
      showPremiumData:{},
      order_id: null,
      marketingList: [],
      customer_profile: {},
      keyAltDown: false,
      showPaidStatus: false,
      copyKey: '',
      status:''
    }
  },
  computed: {
    // orderId(){
    //   let {id} = this.$route.query
    //   return id
    // },
    isHzmb(){
      let {class_id} = this.form||{}
      return class_id==15
    },
    auto_pay_at(){
      let {pre_auto_renewal_info} = this.form||{}
      let {auto_pay_at} = pre_auto_renewal_info||{}
      return auto_pay_at
    },
    share_renew_data(){
      let {share_renew_data} = this.form||{}
      let {share_auto_renew_reopen_data} = share_renew_data||{}
      if(this.status==1)
        return share_auto_renew_reopen_data||''
      return ''
    },
    renew_email_data(){
      let {renew_email_data} = this.form||{}
      let {auto_renew_cancel_data,auto_renew_reopen_data} = renew_email_data||{}
      if(this.status==0)
        return auto_renew_cancel_data
      return auto_renew_reopen_data
    },
    renew_sms_data(){
      let {auto_renew_cancel_data,auto_renew_reopen_data} = this.form||{}
      if(this.status==0)
        return auto_renew_cancel_data
      return auto_renew_reopen_data
    },
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform==2
    },
    coverNoteStatus(){
      return this.form.covernote_status
    },
    coverNoteNum(){
      return this.form.cvr_nt_no
    },
    pcyStts(){
      return this.form.pcy_stts
    },
    sidebarPremium() {
      let {quote_coverage_list={},type,sidebar_info} =this.formData||{}
      if(this.productId==80)
      {
        if(!sidebar_info){
          return []
        }
      }
      else {
        if(!quote_coverage_list) {
          return []
        }
      }
      let params = []
      let { premium=[]} =quote_coverage_list||{}
      let { premium_info=[]} =sidebar_info||{}
      params = this.productId==80?premium_info:premium
      // premium.forEach(item => {
      //   if(item.item == 'MGM Discount'){
      //     this.network().getAccountDetail(item.customer_id)
      //   }
      // })
      return type==50?this.adjustPremium:params||[]
    },
    showAmount(){
      let arr = this.sidebarPremium||[]
      let obj = arr.find(item=>item.name == 'paid')||{}
      return obj.premium||''
    },
    isChange(){
      let {type} = this.formData
      let pre = this.preformData||{}
      if(type!=50) return false
      let {quote_coverage_list={}} =pre||{}
      if(!quote_coverage_list) {
        return false
      }
      let { premium=[]} =quote_coverage_list||{}
      let prePremium = premium.find(item=>item.name == 'paid')||{}
      return this.showAmount != prePremium.premium
    },
    extra_content_premium(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr
    },
    extra_content_pcy(){
      let {extra_content_list={}} = this.formData||{}
      let arr =[]
      if(extra_content_list){
        arr = Object.entries(extra_content_list).map(item=>item[1])
      }
      return arr
    },
    classId() {
      return this.form.class_id || 14
    },
    localAllOptions() {
      if (this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`] || { mortgagor: [] }
      }
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.form
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    productId() {
      return this.form.product_id || null
    },
    currentOrderId() {
      let {id} =this.$route.query
      if(this.isNewSME)
        return  id
      return this.formData.id
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    // 廢棄
    newestOrderId() {
      const {period_record = []} = this.recordList[0]
      if (period_record && period_record.length > 0) {
        const len = period_record.length
        return this.recordList[0].period_record[len - 1].order_id
      }
      return this.recordList[0].order_id
    },
    // 最新單
    newestOrderIdList() {
      if (!this.recordList) return []
      const list = this.recordList.reduce((result, item) => {
        const {period_record = []} = item
        if (period_record && period_record.length > 0) {
          const len = period_record.length
          // 還要判斷是否為 cancel 單， so 遍歷吧
          let flagOrderId = -1
          for (let i = 0; i < len; i++) {
            const {type, order_id} = period_record[i]
            if (type != 40) {
              flagOrderId = order_id
              break
            }
          }
          if (flagOrderId === -1) {
            result.push(item.order_id)
          } else {
            result.push(flagOrderId)
          }
        } else {
          result.push(item.order_id)
        }
        return result
      }, [])
      return list
    },
    showAdjustPolicyBtn() {
      const {stts, adjust_policy_enable, type} = this.formData
      const orderType = Number(type)
      // 定单(新单:10;续保:20; 调整单:50)状态为:410才会有 adjust policy 按钮存在
      if ([301, 310, 401, 410].includes(stts) && [10, 20, 50].includes(orderType)) {
        return true
      }
      return false
    },
    disabledAdjustPolicyBtn() {
      // if(this.newestOrderId != this.formData.id) {
      //   return true
      // }

      if (!this.newestOrderIdList.includes(this.formData.id)) {
        return true
      }
      if (this.formData.adjust_quote_order_id) {
        return true
      }
      if (this.formData.adjust_policy_enable == 0) {
        return true
      }
      if (this.formData.stts == 310) {
        return true
      }
      return false
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    allBenefitsList() {
      if (this.classId == 14) return []
      return this[`allOptions${this.classId}`].benefits || []
    },
    recordList() {
      // 可能要改一下
      if (!this.form.record) return []
      return this.form.record.reduce((result, item) => {
        result.push({
          ...item,
          open: false
        })
        return result
      }, [])
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items=[]} = excess||{}
      if(items.length>0){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage={}} = quote_coverage_list||{}
      return  coverage
    },
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    specialData(){
      let {quote_coverage_list} = this.formData||{}
      let {special_clause={}} = quote_coverage_list||{}
      return  special_clause||{}
    },
    specialList(){
      let { items=[]} = this.specialData||{}
      return items||[]
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preformData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    },
    sign_pic(){
      let {upload_document={},sign_pic={}} = this.formData
      let sign_data = sign_pic||{}
      if(this.productId==80){
        let {sign_files=[{}]} = upload_document||{}
        sign_data = sign_files[0]||{}
      }
      return sign_data.url
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    isNewSME(){
      let {sme_versions} = this.form||{}
      return sme_versions==3
    },
    auto_renewal_info(){
      let {auto_renewal_info} = this.form||{}
      return auto_renewal_info
    },
    card_info(){
      let {card_info} = this.auto_renewal_info||{}
      return card_info||{}
    },
    hasCardInfo(){
      return JSON.stringify(this.card_info)!='{}'
    },
    paid_status_lang(){
      let {paid_status} = this.auto_renewal_info||{}
      let obj = {
        1:'Pending',
        2:'Success ',
        3:'Invalid',
        4:'Sign and Pay'
      }
      return obj[paid_status]
    },
    isMotorTrade(){
      let {class_id} = this.form||{}
      return class_id ==13
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
  },
  watch: {
    oldFormDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.formDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      handler(val, oldVal) {
        if(this.formDataLock !== this.oldFormDataLock) {
          this.formDataLock = this.oldFormDataLock
          this.formData = JSON.parse(JSON.stringify(val))
          // 让子组件获取新的值

          let {id} = this.$route.query
          if (this.isNewSME)
            this.order_id = id
          else this.order_id = this.formData.id
          // 尋找索引
          // if (val.record) {
          //   const { id, record } = val
          //   record.some((item, index) => {
          //     if (item.order_id == id) {
          //       this.activeItem = index
          //       return true
          //     }
          //     let { period_record = [] } = item
          //     if (period_record.length > 0) {
          //       let flag = false
          //       period_record.some((inItem, inIndex) => {
          //         if (inItem.order_id == id) {
          //           this.activeItem = index
          //           this.activeInItem = inIndex
          //           flag = true
          //           return true
          //         }
          //       })
          //       if (flag) return true
          //     }
          //   })
          // }
          // this.formDataLock += 1
          // this.formData = JSON.parse(JSON.stringify(val))
          // 初始化調用數據
          const {pcy_stts, tag_language} = val
          if (pcy_stts && pcy_stts !== -1)
            this.lock += 1
          // if(this.formDataLock !== this.oldFormDataLock) {
          // if(this.lock ==1) {
          // 判断是否只是改变tag，如果只是改变了tag则不在此触发请求
          let res = true
          if (oldVal && oldVal.tag_language) {
            res = JSON.parse(JSON.stringify(tag_language)) == JSON.parse(JSON.stringify(oldVal.tag_language))
          }
          // pcy_stts = -1 説明正在支付中
          if (val && val.record && val.record.length > 0 && pcy_stts !== -1 && res) {
          // this.recordList.find((item, i) => {
          //   if(item.pcy_id == this.pcyId){
          //     this.recordClick(i, item, {
          //       hideLoading: true
          //     })
          //   }
          // })
          }
          this.getData()
        // }
        }
      }
    },
    currentOrderId: {
      immediate: true,
      handler(id) {
        this.$emit('getCurrentOrderId', id)
      }
    },
    formData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.id) {
          this.$emit('changeCurrentFormData', val)
        }
        let {id,type} = val||{}
      }
    },
    recordList: {
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          val.find((item, i) => {
            if(item.pcy_id == this.pcyId){
              this.activeItem = i
              item.period_record.find((subItem, index) => {
                if(subItem.order_id == this.orderId){
                  this.activeInItem = index
                }
              })
            }
          })
        }
      }
    },
    productId: {
      immediate: true,
      handler(val,old){
        if(val && val !== old){
          // if(this.isNewSME)

          // this.handler().getProductData({
          //   pcy_id: this.pcyId,
          //   order_id: this.orderId
          // })
        }
      }
    },
    specialOptions:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.marketing_data){
          let arr = JSON.parse(JSON.stringify(val.marketing_data)) || []
          this.marketingList = arr
        }
      }
    },
  },
  created(){
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('keyup', this.handleKeyUp)
  },
  methods: {
    handleNext({status}){
      this.status = status
      this.showAutoSelectMessage = true
    },
    handlerRenewSkip(content,send_type) {
      let params ={}
      params.is_sms_send =0
      params.is_email_send =0
      params.is_share_send =0
      params.sms_content =''
      params.email_content =''
      params.share_content =''
      params.status = this.status
      this.network().turnAutoRenewal(params)
    },
    handlerRenewSend(data) {
      let params ={}
      let {is_sms_send,content,email_content,share_content,is_share_send,is_email_send} = data ||{}
      params.is_sms_send =is_sms_send
      params.is_email_send =is_email_send
      params.is_share_send =is_share_send
      params.sms_content =content
      params.email_content =email_content
      params.share_content =share_content
      params.status = this.status
      this.network().turnAutoRenewal(params)
    },
    handleChangePaidStatus(){
      this.showPaidStatus = true
    },
    hanldeLoading(val){
      this.$emit('loading', val)
    },
    handleRefreshData(){
      this.handler().getProductData({
        order_id: this.order_id
      })
    },
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    handleShowPremium(index){
      // let {quote_coverage_list={}} =this.formData||{}
      // if(!quote_coverage_list) {
      //   return []
      // }
      // let { premium_cal_detail} =quote_coverage_list||{}
      // let params ={premium:premium_cal_detail||{}}
      // this.showPremiumData = params||{}
      // this.$refs['premium-dialog'].changeDialog()

      let {quote_coverage_list={},sidebar_info={}} =this.formData||{}
      if(this.productId==80){
        if(!sidebar_info)
          return []
      }else {
        if(!quote_coverage_list) {
          return []
        }
      }
      let { premium_cal_detail} =quote_coverage_list||{}
      let { premium_info} =sidebar_info||{}
      let premium = premium_cal_detail
      if(this.productId==80){
        premium = {items:premium_info}
      }
      if(this.isNewSME){
        premium = {items:sidebar_info}
      }
      let params ={premium:premium||{}}
      this.showPremiumData = params||{}
      this.$refs['premium-dialog'].changeDialog()
    },
    handTabName(data){
      this.$emit('tabName',data)
    },
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    recordClick(index, item, params = {}) {
      this.activeItem = index
      const {pcy_id, order_id} = item
      // this.handler().getProductData({
      //   pcy_id,
      //   ...params
      // })
      this.order_id = order_id
      this.$router.push({
        // path: '/records/policy/detail',
        name: 'recordsPolicyDetail',
        query: {
          id: order_id,
          product_id: this.productId,
          pcy_id,
        },
        params: {
          needLoading: true
        }
      })
    },
    recordItemClick(index, inIndex, inItem) {
      this.activeItem = index
      this.activeInItem = inIndex
      const {pcy_id} = this.recordList[index]
      const {order_id} = inItem
      // this.handler().getProductData({
      //   pcy_id,
      //   order_id
      // })
      this.order_id = order_id
      this.$router.push({
        // path: '/records/policy/detail',
        name: 'recordsPolicyDetail',
        query: {
          id: order_id,
          product_id: this.productId,
          pcy_id,
        },
        params: {
          needLoading: true
        }
      })
      // if(this.productId == 12) {
      //   this.network().getHousemaidPolicyDetail({
      //     pcy_id,
      //     order_id
      //   })
      //   return
      // }
      // this.network().getPolicyDetail({
      //   pcy_id,
      //   order_id
      // })
    },
    onAdjustPolicy() {
      // 當前保單數據
      this.$emit('adjust', this.formData)
    },
    routerToQuote(id) {
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: id,
          product_id: this.productId
        }
      })
    },
    handler() {
      return {
        getProductData: (params = {}) => {
          if (this.activeTab == 'Tickets')
            return
          this.formDataLock += 1
          this.formData = this.form
          if(this.productId==80){
            this.network().getSMEPolicyDetail(params)
          }else  this.network().getPolicyDetail(params)
          // switch (Number(this.productId)) {
          //   case 11:
          //     this.network().getPolicyDetail(params)
          //     break
          //   case 12:
          //     this.network().getHousemaidPolicyDetail(params)
          //     break
          //   case 13:
          //     this.network().getWorkingPolicyDetail(params)
          //     break
          //   case 14:
          //     this.network().getTravelPolicyDetail(params)
          //     break
          //   case 15:
          //     this.network().getInteriorPolicyDetail(params)
          //     break
          //   case 16:
          //     this.network().getStudentPolicyDetail(params)
          //     break
          //   case 17:
          //     this.network().getHomefirePolicyDetail(params)
          //     break
          //   case 18:
          //     this.network().getPersonalPolicyDetail(params)
          //     break
          //   case 20:
          //     this.network().getHomefirePolicyDetail(params)
          //     break
          //   case 80: this.network().getSMEPolicyDetail(params)
          //
          // }
        }
      }
    },
    async getData(){
      await  this.network().getPrePolicyDetail()
      this.network().getOrderAdjustPremium()
    },
    tableClick(e){
      if(this.keyAltDown){
        let el = e.target
        if(el.className == 'key-alt-down'){
          // 复制内容到粘贴板
          let textarea = document.createElement('textarea')
          textarea.value = el.innerText
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
      }
    },
    handleKeyDown(e){
      if(e.keyCode == 18){
        this.keyAltDown = true
      }
    },
    handleKeyUp(e){
      if(e.keyCode == 18){
        this.keyAltDown = false
      }
    },
    getKey(key){
      this.copyKey = key
    },
    handlerUser(id){
      if(id){
        this.$router.push({
          path:'/accounts/detail',
          query:{
            customer_id:id
          }
        })
      }
    },
    network() {
      return {
        getSMEPolicyDetail: async params => {
          let {data} = await getSMEPolicyDetail({
            order_id: this.orderId
          },this.classId)
          this.formDataLock += 1
          this.formData = data
          this.getData()
        },

        //车辆
        getPolicyDetail: async params => {
          const {data} = await getPolicyDetail(params,this.productId)
          this.formDataLock += 1
          this.formData = data
          this.getData()
        },
        // //家佣信息
        // getHousemaidPolicyDetail: async params => {
        //   const {data} = await getHousemaidPolicyDetail(params)
        //   this.formDataLock += 1
        //   this.formData = data
        //   this.getData()
        // },
        // //装修
        // getInteriorPolicyDetail: async params => {
        //   const {data} = await getInteriorPolicyDetail(params)
        //   this.formDataLock += 1
        //   this.formData = data
        //   this.getData()
        // },
        // //家佣
        // getHomefirePolicyDetail: async params => {
        //   // console.log('params',params)
        //   const {data} = await getHomefirePolicyDetail(params)
        //   this.formDataLock += 1
        //   // this.formData = this.form
        //   this.formData = data
        //   this.getData()
        // },
        // getTravelPolicyDetail: async params => {
        //   // console.log('params',params)
        //   const {data} = await getTravelPolicyDetail(params)
        //   this.formDataLock += 1
        //   // this.formData = this.form
        //   this.formData = data
        //   this.getData()
        // },
        // getStudentPolicyDetail: async params => {
        //   // console.log('params',params)
        //   const {data} = await getStudentPolicyDetail(params)
        //   this.formDataLock += 1
        //   // this.formData = this.form
        //   this.formData = data
        //   this.getData()
        // },
        // getWorkingPolicyDetail: async params => {
        //   // console.log('params',params)
        //   const {data} = await getWorkingPolicyDetail(params)
        //   this.formDataLock += 1
        //   // this.formData = this.form
        //   this.formData = data
        //   this.getData()
        // },
        // getPersonalPolicyDetail: async params => {
        //   // console.log('params',params)
        //   const {data} = await getPersonalPolicyDetail(params)
        //   this.formDataLock += 1
        //   // this.formData = this.form
        //   this.formData = data
        //   this.getData()
        // },
        getOrderAdjustPremium:async params  =>{
          let {id,type} = this.formData||{}
          if(type!==50)return
          const {data} = await getOrderAdjustPremium({order_id:id,hideLoading: true})
          this.adjustPremium = data.premium||[]
        },
        getPrePolicyDetail: async params => {
          let {type,pre_order_id} = this.formData||{}
          if(type!==50||this.isNewSME)return
          const {data} = await getPolicyDetail({hideLoading:true,pcy_id:this.pcyId,order_id:pre_order_id},this.productId)
          this.preformData = data||{}
        },

        getAccountDetail: async (id) => {
          const {data} = await getAccountDetail({
            customer_id: id
          })
          this.customer_profile = data.customer_profile
        },
        turnAutoRenewal: async params => {
          let {data} = await turnAutoRenewal({
            order_id: this.orderId,
            ...params
          })
          this.$emit('update', false)
          this.$emit('input', false)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../quoting/sme/info";
/deep/.sme-container__info {
  .box {
    //width: 100%!important;
    max-width: 100%!important;
  }
}
.policy-tab {
  display: flex;
  .sub-title {
    display: block;
    padding-bottom: 15px;
    color: #616266;
    font-size: 16px;
  }
  .mg-l-8{
    margin-left: 8px;
  }
  aside {
    width: 218px;
    margin-right: 15px;

    .active {
      background: #d9ecff;
    }

    .policy-list {
      color: #409eff;
      font-size: 12px;

      .bold {
        font-weight: 500;
        font-size: 14px;
      }

      .policy-item {
        padding: 8px;
        cursor: pointer;

        span {
          display: block;
        }
      }

      .policy-status-list {
        margin-top: 1px;
        text-align: right;

        .policy-status-item {
          display: inline-block;
          padding: 8px;
          cursor: pointer;

          .time {
            display: inline-block;
            padding-left: 30px;
          }
        }
      }
    }
  }

  .information-container {
    flex: 1;

    .box {
      margin-bottom: 10px;

      h2 {
        padding-bottom: 5px;
      }

      .sign_pic {
        display: flex;
        justify-content: center;
        background: white;
        img{
          width: 300px;
        }
      }
    }
  }

  .status-bar {
    padding: 15px;
    align-items: center;
    border-radius: 4px;
    font-size: 14px;

    .left {
      span:first-child {
        display: inline-block;
        padding-right: 15px;
        font-weight: bold;
      }
    }
  }

  .status-bar-void {
    background: #C81F1D;

    .left {
      color: white;
    }
  }

  .status-bar-payment {
    background: #fef6b3;

    .left {
      color: #723c14;
    }
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .extra-title{
    font-size: 16px;
  }
  .flex-aglin-icon{
    align-items: center;
    h3{
     padding-bottom: 0;
    }
    .icon{
      font-size: 14px;
      line-height: 16px;
      color: #6A737D;
      margin-left: 5px;
      cursor: pointer;
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
  .marketing{
    .op{
      margin: 8px 0;
    }
  }
  .referrer{
    color: #0366D6;
    font-family: Inter;
    font-size: 12px;
    cursor:pointer;
    line-height: 20px;
    display: inline-block;
  }
  .tags{
    height: 20px;
    .span-status{
      display: inline-block;
      margin-right: 4px;
      padding: 0px 8px;
      height: 20px;
      border-radius: 100px;
      font-size: 12px;
      line-height: 20px;
      font-weight: 600;
      &.blue{
        color:#0366D6;
        border: 1px solid #0366D6;
      }
      &.verified{
        color:#22863a;
        border: 1px solid #22863a;
      }
      &.pending_verify{
        color:#dbab09;
        border: 1px solid #dbab09;
      }
      &.not_verify{
        color:#d73a49;
        border: 1px solid #d73a49;
      }
      &.flag{
        color:#C24E00;
        border: 1px solid #F66A0A;
      }
    }
  }
}
.table-box {
  & + .table-box{
    margin-top: 30px;
  }
  .title{
    width: 100%;
    font-weight: 600;
    font-size: 14px;
    height: 52px;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    justify-content: space-between;
    span{
      padding: 16px;
      display: inline-block;
    }
  }
  .hd{
    border-radius: 6px;
    cursor: pointer;
    span{
      padding: 16px 0;
    }
    .title-name{
      padding-left: 16px;
      font-weight: 600;
      font-size: 14px;
      color: #0366D6;
    }
    .money{
      margin: 0 6px;
      padding: 0px 6px;
      height: 16px;
      background: rgba(209, 213, 218, 0.5);
      border-radius: 100px;
      font-weight: 600;
      color: #24292E;
      line-height: 16px;
    }
    .icon{
      font-weight: 900;
      font-size: 16px;
      color: #0366D6;
    }
    .code{
      float: right;
      padding-right: 16px;
      color: #586069;
    }
  }
  .tr {
    display: flex;
    border: 1px solid #D1D5DA;
    border-top: 0;
    padding: 8px 16px;
    span{
      flex: 1;
      &:first-child{
        font-weight: 600;
        font-size: 14px;
        color: #586069;
      }
      &:last-child{
        color: #24292E;
        font-size: 14px;
      }
    }
    .email{
      .icon{
        font-weight: 900;
        font-size: 14px;
        margin-left: 9px;
      }
      .check{
        color: #22863A;
      }
    }

    .column{
      flex-direction: column;
      align-items: start !important;
    }

    .purple{
      color: #6F42C1 !important;
      .icon{
        margin-right: 4px;
      }
    }

    .column-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      .status{
        color: #B08800;
        font-size: 12px;
        font-weight: 600;
        display: inline-block;
        margin-left: 8px;
      }
      .mt-5 + .mt-5{
        margin-top: 5px;
      }
    }
    &:last-child{
      border-radius: 0px 0px 6px 6px;
    }
    .name{
      color: #0366D6 !important;
      cursor: pointer;
      text-decoration: none;
    }
    .unname{
      font-style: italic;
      cursor: pointer;
      color: #6A737D !important;
    }
  }
}
.color-red{
  color: #CB2431!important;
}
.color-green{
  color: #22863A!important;
}
</style>
